import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {API, CheckEmailPayload, GuestAccountState} from '@chekin/api';
import {FastAPIServiceError} from '@chekin/core';
import {useIsMounted} from '@chekinapp/ui';

type Props = Omit<
  UseMutationOptions<GuestAccountState, FastAPIServiceError, CheckEmailPayload>,
  'mutationFn'
>;
function useCheckEmailMutation({onError, ...options}: Props = {}) {
  const isMounted = useIsMounted();

  return useMutation<GuestAccountState, FastAPIServiceError, CheckEmailPayload>({
    mutationFn: async payload => (await API.auth.checkEmail(payload)).account_state,
    onError: (...args) => {
      if (!isMounted.current) {
        return;
      }

      onError?.(...args);
    },
    ...options,
  });
}

export {useCheckEmailMutation};
